// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HIkt","icon":"styles_icon__EvF_g"};